<template>
  <div class="row">
    <div class="col-md-9">
      <div v-if="newData">
        <!-- List of remaining news -->
        <div class="list-group mt-4">
          <h2 class="fw-bold">
            {{ capitalizeFirstLetter(categoryName) }}({{ newData.length }})
          </h2>
          <div
            v-for="(news, index) in newData.slice(0, count)"
            :key="index"
            class="list-group-item list-group-item-action border-0 news-item d-flex align-items-center"
          
          >
            <img
              :src="news.imageURL"
              class="me-4 news-item-image"
              alt="News Image"
              @click="navigateToDetail(news.id)"
            />
            <div>
              <h5 @click="navigateToDetail(news.id)" class="mb-1 fw-bold">
                {{ news.title }}
              </h5>
              <p class="fw-lighter" @click="navigateToDetail(news.id)">
                {{ news.comment }}
              </p>
            </div>
          </div>
        </div>
        <div class="text-center" v-if="newData.length > count">
          <i
            class="fa-regular fa-plus"
            @click="add()"
            style="color: #000000"
          ></i>
        </div>
        <div v-else>
          <!-- <p class="text-muted">더 이상 기사가 없습니다.</p> -->
        </div>
      </div>

      <div v-else>
        <h2>{{ categoryName }}({{ newData.length  }})</h2>
        <p class="text-muted">기사가 없거나 기사를 불러오는데 실패 했습니다.</p>
      </div>
    </div>
    <div class="col-md-3 pl-md-4">
      <div class="sidebar-box mb-3 border border-black margin-design">
        <h5 class="sidebar-title">여기에 광고 넣어야함</h5>
        <p class="sidebar-content">광고</p>
      </div>
      <div class="d-flex flex-column">
        <div class="sidebar-box mb-3 margin-design" style="width: auto">
          <div
            v-for="(news, index) in all_lastestnewsData.slice(0, 4)"
            :key="index"
            class="border-bottom border-black mouseon mb-2"
          >
            <p
              @click="navigateToDetail(news.id, news.category)"
              class="p fw-bold"
            >
              {{ news.title }}
            </p>
            <p
              @click="navigateToDetail(news.id, news.category)"
              class="p fw-lighter"
            >
            {{ news.comment.slice(0, 200) }}...

            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateViews } from "@/fetchData";
export default {
  props: {
    categoryName: String,
    dbData: {
      type: Object,
      required: true,
    },
    all_lastestnewsData: {
      type: Array,
      required: true,
    },
    all_topnewsData: {
      type: Array,
      required: true,
    },
  },
  watch: {
    dbData: {
      immediate: true,
      handler() {
        this.updateData();
      },
    },
    categoryName() {
      this.updateData();
    },
  },
  data() {
    return {
      count: 10,
    };
  },
  methods: {
    add() {
      this.count += 1;
    },
    updateData() {
      this.newData = this.dbData[this.categoryName] || [];
    },
    async navigateToDetail(itemId, categoryName) {
      const routeData = {
        name: "ItemDetail",
        params: { categoryName: categoryName, id: itemId },
      };

      // Update views count for the item
      try {
        await updateViews(categoryName, itemId);
        console.log("Views updated for item:", itemId);
      } catch (error) {
        console.error("Error updating views:", error);
      }

      // Get the current base URL
      const baseUrl = window.location.origin;

      // Create the URL for the route
      const url = this.$router.resolve(routeData).href;

      // Open the URL in a new tab
      window.open(baseUrl + url, "_blank");
    },
    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>

<style>
.text-muted {
  margin-bottom: 5px;
  font-size: 12px;
}

.text-link {
  display: inline-block;
  margin-top: 10px;
  color: #007bff;
  font-size: 14px;
}

.news-item {
  display: flex;
  margin-bottom: 20px;
  border: 1px solid gainsboro;
}

.mouseon h2:hover,
.mouseon p:hover,
.content-wrapper :hover,
.mouseon h5:hover {
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
}

.news-item .news-image {
  flex: 0 0 200px;
  margin-right: 10px;
}

.news-item-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.news-item .news-content {
  flex: 1;
}
.news-item {
  width: 100%;
}
@media (max-width: 1300px) {
  .news-item {
    flex-direction: column;
    align-items: normal;
    margin-bottom: 20px;
  }

  .news-item .news-image {
    flex: none;
    width: 100%;
    height: auto;
    margin-right: 0;
    margin-bottom: 10px;
  }

  .news-item .news-content {
    flex: none;
  }
  .news-item-image {
    width: 100%;
    height: 100%;
  }
  .me-4 {
    margin-right: 0px !important;
  }
}
</style>
